import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'turnover-month',
    templateUrl: 'data-analysis.component.html',
    styles: [
        `
            h3 input {
                width: 150px;
                display: inline-block;
                margin: 0 15px 9px;
                font-size: 17px;
            }
        `,
    ],
})
export class DataAnalysisComponent implements OnInit {
    toDate: string;
    fromDate: string;

    ngOnInit(): void {
        this.toDate = moment()
            .startOf('month')
            .subtract(1, 'days')
            .format('YYYY-MM-DD');

        this.fromDate = moment(this.toDate).dayOfYear(1).format('YYYY-MM-DD');
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/stats/data-analysis/data-analysis.component.ts